import React, { useState } from 'react';
import { Box, Flex, Switch, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { usePreferences } from '../../contexts/PreferencesContext';
import { useWorkspace } from '../../contexts/WorkspaceContext';
import Card from '../shared/Card';

/**
 * MI-329: the switch between Colombia's official TRM and the market rate for
 * dollar ↔ peso, in the workspaces this user owns.
 *
 * Until the user touches it, it shows what the server applies to their own
 * workspace (the TRM when their country is Colombia). Every converted figure
 * on screen was computed with the old rates, so the page reloads once the
 * choice is saved, as it does when switching workspaces.
 */
export default function RateSourceCard() {
  const { t } = useTranslation('currencies');
  const { rateSource, setRateSource } = usePreferences();
  const { workspaces } = useWorkspace();
  const [saving, setSaving] = useState(false);

  const own = workspaces.find((w) => w.is_personal && w.workspace_role === 'Owner');
  const usesTrm = (rateSource || own?.rate_source) === 'trm';

  const handleChange = async (e) => {
    setSaving(true);
    await setRateSource(e.target.checked ? 'trm' : 'market');
    window.location.reload();
  };

  return (
    <Box mb={5}>
      <Text fontSize="sm" fontWeight={600} color="redesign.heading" mb={2}>
        {t('rateSource.title')}
      </Text>
      <Card borderRadius="lg" px={4}>
        <Flex align="center" justify="space-between" gap={4} py={4}>
          <Box>
            <Text fontSize="sm" fontWeight={500} color="redesign.heading">
              {t('rateSource.label')}
            </Text>
            <Text fontSize="xs" color="redesign.text.muted" mt={0.5}>
              {t('rateSource.description')}
            </Text>
          </Box>
          <Switch
            isChecked={usesTrm}
            isDisabled={saving}
            onChange={handleChange}
            colorScheme="blue"
            aria-label={t('rateSource.aria')}
          />
        </Flex>
      </Card>
    </Box>
  );
}
